module.exports = __webpack_public_path__ + "img/2.70e6cfb2.jpg";